import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import Select from 'component/utils/Select'
import _ from 'lodash'

class SelectType extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,

    value: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.number.isRequired,
    ]),

    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    options: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    label: PropTypes.string,
  }

  constructor(props, context) {
    super(props, context)

    this.state = {
      error: null,
    }

    this.renderOptions = this.renderOptions.bind(this)
  }

  renderOptions(option) {
    return (
      <option key={option.key} value={option.key}>
        {this.props.translate(option.value)}
      </option>
    )
  }

  render() {
    const {
      id,
      name,
      value,
      onChange,
      options,
      label,
      disabled = false,
    } = this.props

    const optionsList = _.map(options, (value, key) => ({ key, value }))

    return (
      <Select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        label={label}
        disabled={disabled}
      >
        {optionsList.map(this.renderOptions)}
      </Select>
    )
  }
}

const OptionSelectTranslated = translate(null, { wait: true })(SelectType)

export default connect()(OptionSelectTranslated)

export { SelectType }
